//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from '~/plugins/axios';
import PageBanner from '../PageBanner.vue';
import PageLimiter from '../PageLimiter.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import Btn from '../Btn.vue';
import IconArrow from '../IconArrow.vue';

export default {
	name: 'PageOvsyanoe',

	components: { PageBanner: PageBanner, PageLimiter: PageLimiter, Breadcrumbs: Breadcrumbs, Btn: Btn, IconArrow: IconArrow },

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	data: function data() {
		return {
			banerBg: function banerBg() {
				if (this.$store.state.settings.lang == 'ru') return '/images/ovsyanoe/min_ret.jpg';else return '/images/ovsyanoe/min_ret_en.jpg';
			}
		};
	},
	mounted: function mounted() {
		if (window.innerWidth <= 575) $('.o_product-item.vertical:first-child').appendTo('.o_products.item-0');
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageOvsyanoe.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageOvsyanoe.vue
// module chunks = 0